// src/pages/PasswordRestore.js  (ruta: /password/restore/:token)
import React, { useState, useRef, useContext, Fragment } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import SwaggerContext from "../../SwaggerContext";
import { PasswordRestoreInputDto } from "../../generated/src";
import { createApiCallback } from "../../utils/error-handler";

/* Validaciones */
const required = (value) =>
  !value && <div className="alert alert-danger" role="alert">Campo obligatorio</div>;

// 8–15, ≥1 letra, ≥1 número, ≥1 símbolo
const vpasswordStrong = (value) => {
  const ok =
    value.length >= 8 &&
    value.length <= 15 &&
    /[A-Za-z]/.test(value) &&
    /\d/.test(value) &&
    /[^A-Za-z0-9]/.test(value);
  if (!ok) {
    return (
      <div className="alert alert-danger" role="alert">
        La contraseña debe tener mínimo 8 y máximo 15 caracteres, e incluir al menos 1 letra, 1 número y 1 símbolo.
      </div>
    );
  }
};

const vpasswordsMatch = (value, _props, components) => {
  const pwd = components.password?.[0]?.value ?? "";
  if (value !== pwd) {
    return <div className="alert alert-danger" role="alert">Las contraseñas no coinciden</div>;
  }
};

const PasswordRestore = () => {
  const form = useRef();
  const checkBtn = useRef();
  const { token } = useParams();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const navigate = useNavigate();
  const { userApi } = useContext(SwaggerContext);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSuccessMsg("");
    setErrorMsg("");

    form.current.validateAll();
    if (checkBtn.current.context._errors.length > 0) return;

    if (!token) {
      setErrorMsg("Enlace inválido o incompleto. Revisa el correo e inténtalo de nuevo.");
      return;
    }

    const dto = new PasswordRestoreInputDto(password, token);
    userApi.restorePassword(dto, createApiCallback(
      () => {
        setSuccessMsg("Contraseña restablecida. Redirigiendo al login en 5 segundos…");
        setTimeout(() => navigate("/login"), 5000);
      },
      (errorMessage) => {
        setErrorMsg(`Error al restablecer la contraseña: ${errorMessage}`);
      }
    ));
  };

  return (
    <div className="col-md-12">
      <div className="card card-container">
        <img
          src="//ssl.gstatic.com/accounts/ui/avatar_2x.png"
          alt="profile-img"
          className="profile-img-card"
        />

        <Form onSubmit={handleSubmit} ref={form}>
          <Fragment>
            <div className="form-group">
              <label htmlFor="password">Nueva contraseña</label>
              <Input
                type="password"
                className="form-control"
                name="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                validations={[required, vpasswordStrong]}
              />
            </div>

            <div className="form-group">
              <label htmlFor="confirmPassword">Confirmar contraseña</label>
              <Input
                type="password"
                className="form-control"
                name="confirmPassword"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                validations={[required, vpasswordsMatch]}
              />
            </div>

            <div className="form-group d-flex justify-content-center pt-4">
              <button className="btn btn-primary">Guardar nueva contraseña</button>
            </div>
          </Fragment>

          {successMsg && (
            <div className="form-group mt-3">
              <div className="alert alert-success" role="alert">
                {successMsg}
              </div>
            </div>
          )}

          {errorMsg && (
            <div className="form-group mt-3">
              <div className="alert alert-danger" role="alert">
                {errorMsg}
              </div>
            </div>
          )}

          <CheckButton style={{ display: "none" }} ref={checkBtn} />
        </Form>

        <div className="text-center mt-3">
          <button
            type="button"
            className="btn btn-link"
            onClick={() => navigate("/login")}
          >
            Iniciar sesión
          </button>
        </div>
      </div>
    </div>
  );
};

export default PasswordRestore;